import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import wipiaWImg from '../../assets/img/wipia-w.png';
import LoadExternalJS from "../../js/loadExternalJS";
import "./headerTheme.css";
import { useContext } from "react";
import { ArgContext } from "../../Context/ArgProvider";
import { navMenus } from "./menu";

function Header() {
  LoadExternalJS();
  const location = useLocation();
  const pathname = location.pathname;
  
  // 화면 이동을 위한 네비게이터 설정
  const navigate = useNavigate();

  const navRef = useRef(null);
  const navBtnRef = useRef(null);
  const navBgRef = useRef(null);

  const { argInfo } = useContext(ArgContext);
  
  // 모바일에서 열린 메뉴 인덱스 상태 (초기값을 현재 페이지 메뉴로 설정)
  const [openMenuIndex, setOpenMenuIndex] = useState(() => {
    const currentIndex = navMenus.findIndex(menu => {
      if (menu.groups) {
        return menu.groups.some(group => 
          group.children.some(child => pathname.includes(child.path))
        );
      } else if (menu.children) {
        return menu.children.some(sub => pathname.includes(sub.path));
      }
      return pathname.includes(menu.path);
    });
    return currentIndex >= 0 ? currentIndex : null;
  });

  // 모바일 메뉴 클릭 핸들러
  const handleMenuClick = useCallback((e, clickedIndex) => {
    const isMobile = window.innerWidth <= 1023;
    if (!isMobile) return;

    // depth2의 링크를 클릭한 경우
    if (e.target.closest('.dropdown-list')) {
      const clickedLink = e.target.closest('.dropdown-list');
      const clickedPath = clickedLink.getAttribute('href');
      
      // 현재 페이지와 같은 링크를 클릭한 경우 메뉴만 닫기
      if (pathname === clickedPath) {
        e.preventDefault();
        e.stopPropagation();
        
        // 모바일 메뉴 닫기
        const nav = document.querySelector('nav');
        const navBtn = document.querySelector('.navBtn');
        if (nav && navBtn) {
          nav.classList.remove('active');
          navBtn.classList.remove('active');
          document.body.style.overflow = '';
        }
        
        // 열린 메뉴 상태 초기화
        setOpenMenuIndex(null);
        return;
      }
      return;
    }

    // 1depth 메뉴 제목을 클릭한 경우
    if (e.target.classList.contains('menu-title-span')) {
      e.preventDefault();
      e.stopPropagation();
      
      // 클릭한 메뉴 토글 (현재 페이지 메뉴도 포함)
      setOpenMenuIndex(prevIndex => {
        if (prevIndex === clickedIndex) {
          // 같은 메뉴를 클릭했으면 닫기
          return null;
        } else {
          // 다른 메뉴를 클릭했으면 기존 메뉴 닫고 새 메뉴 열기
          return clickedIndex;
        }
      });
    }
  }, [pathname]);

  // depth2 메뉴 링크 클릭 이벤트 처리
  const handleDepth2LinkClick = useCallback((e) => {
    const isMobileView = window.innerWidth <= 1023;
    if (!isMobileView) return;

    const clickedLink = e.target.closest('.dropdown-list');
    if (clickedLink) {
      const clickedPath = clickedLink.getAttribute('href');
      
      // 현재 페이지와 같은 링크를 클릭한 경우 메뉴만 닫기
      if (window.location.pathname === clickedPath) {
        e.preventDefault();
        e.stopPropagation();
        
        // 모바일 메뉴 닫기
        const nav = document.querySelector('nav');
        const navBtn = document.querySelector('.navBtn');
        if (nav && navBtn) {
          nav.classList.remove('active');
          navBtn.classList.remove('active');
          document.body.style.overflow = '';
        }

        return;
      }
    }
  }, []);

  // 현재 메뉴 그룹 찾기
  const currentGroup = navMenus.find(menu => {
    if (menu.groups) {
      // groups 구조인 경우 각 그룹의 children을 확인
      return menu.groups.some(group => 
        group.children.some(child => pathname.includes(child.path))
      );
    } else if (menu.children) {
      return menu.children.some(sub => pathname.includes(sub.path));
    }
    return pathname.includes(menu.path);
  });

    useEffect(() => {
    // adminLogin 페이지에서는 이벤트 리스너를 추가하지 않음
    if (window.location.pathname === '/adminLogin') return;

    // dropdown-list에 on 클래스가 있을 때 해당 상위 menu-group에도 on 클래스 추가
    const updateMenuGroupStates = () => {
      const activeDropdownLists = document.querySelectorAll('.dropdown-list.on');
      const allMenuGroups = document.querySelectorAll('.menu-group');
      
      // 모든 menu-group에서 on 클래스 제거
      allMenuGroups.forEach(group => {
        group.classList.remove('on');
      });
      
      // active한 dropdown-list가 있는 menu-group에 on 클래스 추가
      activeDropdownLists.forEach(dropdown => {
        const menuGroup = dropdown.closest('.menu-group');
        if (menuGroup) {
          menuGroup.classList.add('on');
        }
      });
    };

    requestAnimationFrame(() => {
      const nav = navRef.current;
      const navBtn = navBtnRef.current;
      const navBg = navBgRef.current;

      if (!nav || !navBtn || !navBg) {
        console.warn("DOM 요소가 없습니다.", { nav, navBtn, navBg });
        return;
      }
      
      const handleClick = () => {
        nav.classList.toggle('active');
        navBtn.classList.toggle('active');
        
        // 모바일 메뉴가 열릴 때 스크롤 방지
        if (nav.classList.contains('active')) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      };

      const handleBgClick = () => {
        nav.classList.remove('active');
        navBtn.classList.remove('active');
        document.body.style.overflow = ''; // 스크롤 복원
      };

      navBtn.addEventListener('click', handleClick);
      navBg.addEventListener('click', handleBgClick);

      const menuItems = document.querySelectorAll('.header nav > ul > li');
      const isMobile = window.innerWidth <= 1023;

      function handleMouseEnter(e) {
        const isMobileView = window.innerWidth <= 1023;
        if (!isMobileView) {
          const depth2 = e.currentTarget.querySelector('.depth2');
          if (depth2) {
            if (depth2.classList.contains('aiMenu')) {
              depth2.style.display = "grid";
            } else {
              depth2.style.display = "flex";
            }
            depth2.style.opacity = 1;
          }
        }
      }

      function handleMouseLeave(e) {
        const isMobileView = window.innerWidth <= 1023;
        if (!isMobileView) {
          const depth2 = e.currentTarget.querySelector('.depth2');
          if (depth2) {
            depth2.style.opacity = 0;
            depth2.style.display = 'none';
          }
        }
      }

      menuItems.forEach(item => {
        item.addEventListener('mouseenter', handleMouseEnter);
        item.addEventListener('mouseleave', handleMouseLeave);
      });

      // depth2 메뉴 링크에 클릭 이벤트 리스너 추가
      const depth2Links = document.querySelectorAll('.dropdown-list');
      depth2Links.forEach(link => {
        link.addEventListener('click', handleDepth2LinkClick);
      });

      const handleResize = () => {
        const newIsMobile = window.innerWidth <= 1025;
        if (newIsMobile !== isMobile) {
          // 모바일 상태가 변경될 때 열린 메뉴 초기화
          setOpenMenuIndex(null);
          // 모바일로 변경 시 스크롤 복원
          document.body.style.overflow = '';
        }
      };

      const handleScroll = () => {
        const header = document.querySelector('header');
        if (!header) return;

        if (window.scrollY > 20) {
          header.classList.add('scroll-on');
        } else {
          header.classList.remove('scroll-on');
        }
      };

      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);
      
      // 초기 상태 업데이트
      updateMenuGroupStates();

              return () => {
          menuItems.forEach(item => {
            item.removeEventListener('mouseenter', handleMouseEnter);
            item.removeEventListener('mouseleave', handleMouseLeave);
          });
          
          // depth2 링크 이벤트 리스너 제거
          const depth2Links = document.querySelectorAll('.dropdown-list');
          depth2Links.forEach(link => {
            link.removeEventListener('click', handleDepth2LinkClick);
          });
          
          navBtn.removeEventListener('click', handleClick);
          navBg.removeEventListener('click', handleBgClick);
          window.removeEventListener('scroll', handleScroll);
          window.removeEventListener('resize', handleResize);
          // 컴포넌트 언마운트 시 스크롤 복원
          document.body.style.overflow = '';
          // 열린 메뉴 상태 초기화
          setOpenMenuIndex(null);
                };
      });
         }, []);

  // 경로가 변경될 때마다 menu-group 상태 업데이트 및 현재 페이지 메뉴 상태 업데이트
  useEffect(() => {
    const updateMenuGroupStates = () => {
      const activeDropdownLists = document.querySelectorAll('.dropdown-list.on');
      const allMenuGroups = document.querySelectorAll('.menu-group');
      
      // 모든 menu-group에서 on 클래스 제거
      allMenuGroups.forEach(group => {
        group.classList.remove('on');
      });
      
      // active한 dropdown-list가 있는 menu-group에 on 클래스 추가
      activeDropdownLists.forEach(dropdown => {
        const menuGroup = dropdown.closest('.menu-group');
        if (menuGroup) {
          menuGroup.classList.add('on');
        }
      });
    };

    // 현재 페이지 메뉴 인덱스 업데이트
    const currentIndex = navMenus.findIndex(menu => {
      if (menu.groups) {
        return menu.groups.some(group => 
          group.children.some(child => pathname.includes(child.path))
        );
      } else if (menu.children) {
        return menu.children.some(sub => pathname.includes(sub.path));
      }
      return pathname.includes(menu.path);
    });
    
    if (currentIndex >= 0) {
      setOpenMenuIndex(currentIndex);
    } else {
      setOpenMenuIndex(null);
    }

    // DOM이 업데이트된 후 실행
    setTimeout(updateMenuGroupStates, 0);
  }, [pathname]);
  
  function moveTo(path) {
	// window.location.href=path;		// 라우터 기능 사용되지 않음
	navigate(path);
  }
  
  return (
    <header className="header">
      <div className="headerInner">
        <Link to="/" className="logoArea">
          <img src={wipiaWImg} width="100" alt="WIPIA" />
        </Link>
        <button className="navBtn" ref={navBtnRef}>
          <span></span>
          <span></span>
          <span></span>
        </button>
                  <nav id="navbarNav" ref={navRef}>
            <div className="nav-top">
            </div>
          <ul>
            {navMenus.map((menu, index) => (
                             <li key={index} className={`${currentGroup?.title === menu.title ? 'current-menu' : ''} ${openMenuIndex === index ? 'on' : ''}`}>
                                 {menu.groups ? (
                   <>
                     <span className="menu-title-span" onClick={(e) => handleMenuClick(e, index)}>{menu.title}</span>
                    <div className={`depth2 groups-container ${menu.title === 'AI Business' ? 'aiMenu' : ''}`}>
                      {menu.groups.map((group, groupIndex) => (
                        <div key={groupIndex} className="menu-group">
                          <h4 className="group-title">{group.title}</h4>
                          <ul className="group-items">
                            {group.children
                              .filter(child => {
                                // '회사연혁 리스트'는 관리자만 보이게
                                if (child.title === '회사연혁 리스트' && argInfo?.role !== 'admin') return false;
                                return true;
                              })
                              .map((child, childIndex) => (
                                <li key={childIndex}>
                                  <Link 
                                    to={child.path} 
                                    className={`dropdown-list ${pathname.includes(child.path) ? 'on' : ''}`}
                                  >
                                    <div className="menu-item-content">
                                      <span className="menu-title">{child.title}</span>
                                      {child.desc && <span className="menu-desc">{child.desc}</span>}
                                    </div>
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </>
                                 ) : menu.children ? (
                   <>
                     <span className="menu-title-span" onClick={(e) => handleMenuClick(e, index)}>{menu.title}</span>
                    <ul className={`depth2 ${menu.title === 'AI Business' ? 'aiMenu' : ''}`} >
                      {menu.children
                        .filter(child => {
                          // '회사연혁 리스트'는 관리자만 보이게
                          if (child.title === '회사연혁 리스트' && argInfo?.role !== 'admin') return false;
                          return true;
                        })
                        .map((child, childIndex) => (
                          <li key={childIndex}>
                            <Link 
                              to={child.path} 
                              className={`dropdown-list ${pathname.includes(child.path) ? 'on' : ''}`}
                            >
                              {child.title}
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </>
                ) : (
                  <Link 
                    to={menu.path} 
                    className={`nav-list ${pathname.includes(menu.path) ? 'on' : ''}`}
                  >
                    {menu.title}
                  </Link>
                )}
              </li>
            ))}
          </ul>
          <div className="navBg" ref={navBgRef}></div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
